<template>
  <div>
    <div class="d-flex align-items-center justify-content-between">
      <h5>Competitors</h5>
      <div>
        <b-button variant="primary" class="mr-1" @click="emitSave">
          <feather-icon icon="SaveIcon" />
          Save
        </b-button>
        <b-button variant="success" @click="addRow">
          <feather-icon icon="PlusIcon" />
          Add Competitor
        </b-button>
      </div>
    </div>
    <div class="mb-1">
      <span>
        Loaded: {{ competitors.length }} Click to Edit Rows, Save the Event to
        Update
      </span>
    </div>

    <table class="w-100 competitors-table">
      <thead style="background: #f9fafb">
        <tr>
          <th v-if="!isFutureRace" style="width: 50px">Number</th>
          <th style="width: 250px">Name</th>
          <th style="width: 80px">Scratched</th>
          <th v-if="!isFutureRace">Trainer</th>
          <th v-if="!isFutureRace">Jockey</th>
          <th v-if="!isFutureRace">Barrier</th>
          <th class="text-center" style="width: 130px">Odds</th>
          <th class="text-center">Comment</th>
          <th style="width: 80px">Delete</th>
        </tr>

        <tr>
          <th :colspan="isFutureRace ? 2 : 6"></th>
          <th class="text-center">F:</th>
          <th></th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(competitor, index) in competitors"
          :key="index"
          :class="{ 'yellow-competitor': competitor.isNew }"
        >
          <!-- Number -->
          <td v-if="!isFutureRace">
            <b-form-input
              type="number"
              v-model="competitor.runnerNo"
              size="sm"
            />
          </td>

          <!-- Name + Silk -->
          <td>
            <div class="d-flex align-items-center" style="gap: 8px">
              <b-form-input
                type="text"
                v-model="competitor.runnerName"
                size="sm"
              />
            </div>
          </td>

          <!-- Scratched -->
          <td>
            <b-form-checkbox v-model="competitor.scratched" />
          </td>

          <!-- Trainer -->
          <td v-if="!isFutureRace">
            <b-form-input type="text" v-model="competitor.trainner" size="sm" />
          </td>

          <!-- Jockey -->
          <td v-if="!isFutureRace">
            <b-form-input type="text" v-model="competitor.jockey" size="sm" />
          </td>

          <!-- Barrier -->
          <td v-if="!isFutureRace">
            <b-form-input
              type="number"
              v-model="competitor.barrierPosition"
              size="sm"
            />
          </td>

          <!-- Odds F -->
          <td>
            <div class="odds-cell">
              <div class="d-flex align-items-center odds-competitor">
                <span class="text-muted odds-label">F:</span>

                <b-form-input
                  type="number"
                  step="0.01"
                  size="sm"
                  class="odds-input"
                  v-model="competitor.price"
                />

                <feather-icon icon="ChevronUpIcon" class="odds-up" />
              </div>

              <div class="d-flex align-items-center odds-competitor">
                <span class="text-muted odds-label">T:</span>

                <b-form-input
                  type="number"
                  step="0.01"
                  size="sm"
                  class="odds-input"
                  v-model="competitor.placePrice"
                />

                <feather-icon icon="ChevronUpIcon" class="odds-up" />
              </div>
            </div>
          </td>

          <td>
            <div class="d-flex align-items-center">
              <b-form-textarea v-model="competitor.note" max-rows="2" />
            </div>
          </td>

          <!-- Delete -->

          <td class="text-center">
            <b-button variant="danger" size="sm" @click="remove(competitor)">
              <feather-icon icon="TrashIcon" />
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import {
  BFormInput,
  BFormCheckbox,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";
import { mapActions } from "vuex";
import { v4 as uuidv4 } from "uuid";
import useToastHandler from "@/services/toastHandler";

const COMPARE_FIELDS = [
  "runnerNo",
  "runnerName",
  "scratched",
  "trainner",
  "jockey",
  "barrierPosition",
  "price",
  "placePrice",
  "note",
];

export default {
  components: {
    BFormInput,
    BFormCheckbox,
    BButton,
    BFormTextarea,
  },
  computed: {
    isFutureRace() {
      return this.$route.query.type === "future";
    },
  },
  data() {
    return {
      competitors: [],
      originalRunners: {},
    };
  },
  created() {
    this.handleGetRunners();
  },
  methods: {
    ...mapActions("trading/racing", ["getRunnersOfRace"]),
    async handleGetRunners() {
      try {
        const raceId = this.$route.query.raceId;
        const runners = await this.getRunnersOfRace(raceId);
        if (!runners) return;
        this.competitors = runners?.map((runner) => ({
          ...runner,
          isNew: false,
          scratched: !!runner.scratched,
          price: Number(runner.price).toFixed(2) || 0,
          placePrice: Number(runner.placePrice).toFixed(2) || 0,
        }));
        this.markSaved();
      } catch (e) {
        console.error("Failed to load competitors:", e);
      }
    },
    addRow() {
      this.competitors.push({
        id: uuidv4(),
        runnerNo: "",
        runnerName: "",
        scratched: false,
        trainner: "",
        jockey: "",
        barrierPosition: "",
        price: 0,
        placePrice: 0,
        isNew: true,
      });
    },
    remove(item) {
      this.competitors = this.competitors.filter((competitor) => {
        if (competitor.isNew && competitor.id === item.id) {
          return competitor.id !== item.id;
        }
        return competitor.runnerId !== item.runnerId;
      });
    },
    toPayload(r) {
      return {
        ...r,
        scratched: r.scratched ? 1 : 0,
        runnerNo: Number(r.runnerNo) || null,
        barrierPosition: Number(r.barrierPosition) || null,
        price: Number(r.price) || null,
        placePrice: Number(r.placePrice) || null,
      };
    },
    getChangedFields(runner) {
      const original = this.originalRunners[runner.runnerId];
      if (!original) return COMPARE_FIELDS;
      return COMPARE_FIELDS.filter(
        (field) => (runner[field] ?? "") !== (original[field] ?? "")
      );
    },
    // Snapshot current rows so the next save only sends rows edited after this point
    markSaved() {
      this.originalRunners = this.competitors.reduce((acc, r) => {
        if (!r.isNew) acc[r.runnerId] = this.toPayload(r);
        return acc;
      }, {});
    },
    emitSave() {
      const changes = this.competitors
        .map(this.toPayload)
        .map((r) => ({
          runner: r,
          fields: r.isNew ? COMPARE_FIELDS : this.getChangedFields(r),
        }))
        .filter(({ fields }) => fields.length);
      if (!changes.length) {
        this.showToastError("No changes to save");
        return;
      }
      // Scratching alone doesn't conflict with synced race data, so it skips the disable-sync prompt
      const onlyScratchedChanged = changes.every(
        ({ fields }) => fields.length === 1 && fields[0] === "scratched"
      );
      // New rows need the full record; existing rows only send runnerId + edited fields
      const runners = changes.map(({ runner, fields }) =>
        runner.isNew
          ? runner
          : fields.reduce(
              (acc, field) => ({ ...acc, [field]: runner[field] }),
              { runnerId: runner.runnerId }
            )
      );
      this.$emit("save-runners", runners, { onlyScratchedChanged });
    },
  },
  setup() {
    const { showToastError } = useToastHandler();
    return { showToastError };
  },
};
</script>
<style scoped>
.competitors-table {
  overflow-x: auto;
}
.competitors-table th,
.competitors-table td {
  padding: 8px 10px !important;
  vertical-align: middle;
}

.odds-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.odds-competitor {
  gap: 6px;
}

.odds-label {
  width: 18px;
  font-size: 12px;
}

.odds-input {
  width: 70px;
  padding: 4px !important;
  font-size: 12px;
}

.odds-up {
  margin-left: 4px;
  cursor: pointer;
}
</style>
